export default __webpack_public_path__ + "./image/5418d6c4bee7e9d1d61a2c7f62dc27ed.png";